import { resolveIdDescriptor, resolveMinMax } from '../../../../../../util/searchParamNameUtils';

export const resolveSearchParameters = ({
  params: {
    minLatitude,
    maxLatitude,
    country,
    morphology,
    status,
    timeErupt,
    region,
    nameInclude,
    nameMatch,
    nameStart,
    nameNot,
    id,
    newNum,
    num,
    minId,
    maxId,
  },
  regions,
}) => {
  const messages = [];

  if (region != null) {
    messages.push(`Region = ${resolveIdDescriptor(regions, region)}`);
  }

  if (country != null) {
    messages.push(`Country = ${country}`);
  }

  if (nameStart != null) {
    messages.push(`Name starts with '${nameStart}'`);
  }

  if (nameMatch != null) {
    messages.push(`Name = '${nameMatch}'`);
  }

  if (nameInclude != null) {
    messages.push(`Name contains '${nameInclude}'`);
  }

  if (nameNot != null) {
    messages.push(`Name != '${nameNot}'`);
  }

  resolveMinMax('Latitude', minLatitude, maxLatitude, messages);

  if (morphology != null) {
    messages.push(`Morphology = ${morphology}`);
  }

  if (status != null) {
    messages.push(`Status = ${status}`);
  }

  if (timeErupt != null) {
    messages.push(`Eruption time = ${timeErupt}`);
  }


  if (id != null) {
    messages.push(`NCEI ID = ${id}`);
  }
  if (newNum != null) {
    messages.push(`Volcano Number = ${newNum}`);
  }
  if (num != null) {
    messages.push(`Previous Volcano Number = ${num}`);
  }
  resolveMinMax('NCEI ID', minId, maxId, messages);

  return messages;
};
